import React from 'react';
import { Pressable, View } from 'react-native';
import { radius, useColors } from '../theme';
import { Icon } from '../icons/Icon';
import type { IconName } from '../icons/Icon';
import { CountBadge } from './CountBadge';
import { T } from './Text';

export function NavItem({
  icon,
  label,
  active,
  vertical,
  badge,
  testID,
  onPress,
}: {
  icon: IconName;
  label: string;
  active: boolean;
  vertical: boolean;
  badge?: number;
  testID?: string;
  onPress: () => void;
}) {
  const colors = useColors();
  const tint = active ? colors.gold : colors.textDim;

  return (
    <Pressable
      onPress={onPress}
      testID={testID}
      style={({ hovered }: any) => ({
        flex: vertical ? 1 : undefined,
        flexDirection: vertical ? 'column' : 'row',
        alignItems: 'center',
        justifyContent: vertical ? 'center' : 'flex-start',
        gap: vertical ? 4 : 11,
        paddingVertical: vertical ? 7 : 10,
        paddingHorizontal: vertical ? 2 : 12,
        borderRadius: vertical ? 10 : radius.md,
        borderWidth: 1,
        borderColor: active && !vertical ? colors.line : 'transparent',
        backgroundColor: active
          ? vertical
            ? colors.surface
            : colors.surface2
          : hovered && !vertical
            ? colors.surface
            : 'transparent',
      })}
    >
      <View>
        <Icon name={icon} size={vertical ? 19 : 17} color={tint} />
        {badge ? (
          <View style={{ position: 'absolute', top: -7, right: -11 }}>
            <CountBadge value={badge} />
          </View>
        ) : null}
      </View>
      <T
        size={vertical ? 9.5 : 13.5}
        weight={active ? 700 : 600}
        color={tint}
        numberOfLines={1}
      >
        {label}
      </T>
    </Pressable>
  );
}
